import { defineModule, localActionContext } from 'direct-vuex';
import { AutoFactory, DataMaskedField, OnlinePortalFormDataApi } from '@sageworks/jpi';

// eslint-disable-next-line no-use-before-define
const actionContext = (context: any) => localActionContext(context, DataMaskedFieldsModule);

export interface DataMaskedFieldsModuleState {
	dataMaskedFields: DataMaskedField[] | null;
}
const DataMaskedFieldsModule = defineModule({
	namespaced: true,
	state: () => {
		return {
			dataMaskedFields: null
		} as DataMaskedFieldsModuleState;
	},
	mutations: {
		SET_DATA_MASKED_FIELDS(state, dataMaskedFields: DataMaskedField[]) {
			state.dataMaskedFields = dataMaskedFields;
		}
	},
	actions: {
		async loadDataMaskedFields(context): Promise<void> {
			const { commit } = actionContext(context);

			const service = AutoFactory.get(OnlinePortalFormDataApi);
			const dataMaskedFields = await service.getDataMaskedFields();
			commit.SET_DATA_MASKED_FIELDS(dataMaskedFields);
		}
	}
});

export default DataMaskedFieldsModule;
